export default function NewSyncableSectionBodyChangeController(
  pmSharedModelService
) {
  const vm = this;

  // _activate();

  // function _activate() {
  //   const bodyCurrent = vm.change.valueCurrent || '';
  //   const bodyTo = vm.change.valueTo || '';
  //   vm.change.tokenizedBody = pmSharedModelService.replaceTokens(bodyCurrent);
  //   vm.change.tokenizedNewBody = pmSharedModelService.replaceTokens(bodyTo);
  //   // vm.change.breadcrumb = breadcrumb();
  // }
  // function breadcrumb() {
  //   return vm.change.breadcrumbs.join(' -> ');
  // }
}

NewSyncableSectionBodyChangeController.$inject = [
  'pmSharedModelService',
];
